import { Label, Text } from '@beamery/lib-ds-components';
import styled from 'styled-components';
import type { ComponentProps } from 'react';

interface LabelWithRequiredProps extends ComponentProps<typeof Label> {
  isRequired?: boolean;
  isConditionallyRendered?: boolean;
  conditionalText?: string;
}

const ElementLabel = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: ${({ theme }) => theme.space.x3};
  line-height: ${({ theme }) => theme.lineHeights.s};
`;

const ConditionalText = styled(Text)`
  white-space: nowrap;
  display: flex;
  align-items: flex-end;
`;

export const LabelWithRequired = ({
  children,
  isRequired,
  isConditionallyRendered = false,
  conditionalText,
  className,
  ...rest
}: LabelWithRequiredProps) => (
  <ElementLabel className={className}>
    <Label {...rest}>
      {children}
      {isRequired && (
        <>
          {' '}
          <Text aria-hidden color='error'>
            *
          </Text>
        </>
      )}
    </Label>
    {isConditionallyRendered && conditionalText ? (
      <ConditionalText fontSize='xs' color='secondary'>
        {conditionalText}
      </ConditionalText>
    ) : null}
  </ElementLabel>
);
